class BaseModel {
  constructor(data?: object) {
    this.setData(data);
  }

  setData(data: any) {
    data = data || {};

    Object.assign(this, data);
  }
}

export default BaseModel;
